import moment from "moment";

export const initialStudentRecordState = {
  studentReport: {},
  lessonCompleted: false,
  lessonDateCompleted: moment().format("YYYY-MM-DD"),
  lessonDetail: {},
  lessonFiles: [],
  partTimeTeacherAttendanceApproved: false,
  studentDetail: {},
  studentReportAdded: false,
  studentReportApproved: false,
  id: "",
};

export const initialStudentRecordTableModalState = {
  show: false,
  studentRecord: initialStudentRecordState,
};

export const studentRecordTableModalReducerActions = {
  OPEN: 0,
  HIDE: 1,
};

export const studentRecordTableModalReducer = (state, action) => {
  switch (action.type) {
    case studentRecordTableModalReducerActions.OPEN:
      return {
        ...state,
        show: true,
        studentRecord: { ...action.payload },
      };
    case studentRecordTableModalReducerActions.HIDE:
      return initialStudentRecordTableModalState;
    default:
      return state;
  }
};

export const initialAddStudentRecordState = {
  show: false,
  lessonDetail: {},
};

export const addStudentRecordReducerActions = {
  OPEN: 0,
  HIDE: 1,
};

export const addStudentRecordModalReducer = (state, action) => {
  switch (action.type) {
    case addStudentRecordReducerActions.OPEN:
      return {
        ...state,
        show: true,
        lessonDetail: {
          ...action.payload.lessonDetail,
          students: action.payload.students,
        },
      };
    case addStudentRecordReducerActions.HIDE:
      return { ...state, show: false, lessonDetail: {} };
    default:
      throw new Error("Invalid Action at addstudentRecordModalReducer");
  }
};

export const modalAction = {
  OPEN: 0,
  CLOSE: 1,
};

export const modalInitialState = {
  show: false,
  data: {},
};

export const modalReducer = (state, action) => {
  switch (action.type) {
    case modalAction.OPEN:
      return { ...state, show: true, data: action.payload };

    case modalAction.CLOSE:
      return modalInitialState;

    default:
      throw new Error("Invalid action at confirmation modal reducer");
  }
};

